import { CheckCircle } from "@mui/icons-material";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Snackbar,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import DownloadIcon from "@mui/icons-material/Download";
import { UrlApi } from "../../../../services/apirest";

function DescargarCsv({ open, onClose, rendicion }) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [openSnack, setOpenSnack] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [snackSeverity, setSnackSeverity] = useState("success");

  const handleSubmit = async () => {
    setIsSubmitting(true);

    try {
      const csvResp = await fetch(
        `${UrlApi}/csv_envasado/${rendicion.uuid}/${localStorage.getItem(
          "sucursal"
        )}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!csvResp.ok) {
        throw new Error("Error al Decargar el CSV");
      }

      // Éxito
      setMensaje("CSV descargado correctamente");
      setSnackSeverity("success");
      setOpenSnack(true);

      // Cierre automático tras mostrar el snackbar
      setTimeout(() => {
        onClose(true);
      }, 1500);

    } catch (error) {
      console.error("Error al Decargar el CSV:", error);

      setMensaje("Error al descargar el CSV: " + error.message);
      setSnackSeverity("error");
      setOpenSnack(true);

    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Dialog open={open} onClose={() => onClose(false)} maxWidth="xs" fullWidth>
        <Box justifyContent="center" backgroundColor="#1F618D">
          <DialogTitle>
            <Typography fontSize={20} align="center" color="#ffffff">
              Descargar CSV de la rendición
            </Typography>
            <Typography fontSize={20} align="center" color="#ffffff">
              {rendicion.nro_rendicion}
            </Typography>
          </DialogTitle>
        </Box>

        <DialogContent>
          <Box mb={2}>
            <Typography variant="body2" color="textSecondary">
              Descarga de CSV con los datos de los pedidos de la rendición.
            </Typography>
          </Box>
        </DialogContent>

        <Grid container padding={2} direction="row" justifyContent="space-between">
          <Grid item>
            <Button color="error" variant="outlined" onClick={() => onClose(false)}>
              Cancelar
            </Button>
          </Grid>

          <Grid item>
            <Button
              onClick={handleSubmit}
              variant="contained"
              color="primary"
              startIcon={
                isSubmitting ? <CircularProgress size={20} color="inherit" /> : <DownloadIcon />
              }
              disabled={isSubmitting}
            >
              Descargar CSV
            </Button>
          </Grid>
        </Grid>
      </Dialog>

      {/* SNACKBAR */}
      <Snackbar
        open={openSnack}
        autoHideDuration={3000}
        onClose={() => setOpenSnack(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setOpenSnack(false)}
          severity={snackSeverity}
          sx={{ width: "100%" }}
        >
          {mensaje}
        </Alert>
      </Snackbar>
    </>
  );
}

export default DescargarCsv;
